import { render, staticRenderFns } from "./HygienistsSingle.vue?vue&type=template&id=4075acb4&scoped=true"
import script from "./HygienistsSingle.vue?vue&type=script&lang=js"
export * from "./HygienistsSingle.vue?vue&type=script&lang=js"
import style0 from "./HygienistsSingle.vue?vue&type=style&index=0&id=4075acb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075acb4",
  null
  
)

export default component.exports